import React from 'react';
import { AnimatedSection } from '../shared/AnimatedSection';
import { GlowCard } from '../shared/GlowCard';
import { Sign } from '../../data/signs';
interface SignProblemaProps {
  sign: Sign;
}
export function SignProblema({
  sign
}: SignProblemaProps) {
  const {
    problemaTitle,
    problemaSubtitle,
    problemas
  } = sign.content;
  return <section className="py-20 px-6 bg-transparent" data-id="element-376">
      <div className="container mx-auto max-w-5xl" data-id="element-377">
        <AnimatedSection data-id="element-378">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-center text-white mb-4" data-id="element-379">
            {problemaTitle}
          </h2>
          <h3 className="text-xl md:text-2xl font-serif text-center mb-12 italic" style={{
          color: sign.colors.accent
        }} data-id="element-380">
            {problemaSubtitle}
          </h3>
        </AnimatedSection>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-381">
          {problemas.map((problema, index) => <AnimatedSection key={index} delay={0.2 + index * 0.1} data-id="element-382">
              <GlowCard glowColor={sign.colors.primary} className="h-full" data-id="element-383">
                <p className="text-gray-200 leading-relaxed" data-id="element-384">{problema}</p>
              </GlowCard>
            </AnimatedSection>)}
        </div>
      </div>
    </section>;
}